import React from "react";
import { Beer } from "lucide-react";

import { cn } from "@workspace/ui/lib/utils";

export const PageLoading = React.memo(
	({
		text = <h2 className="text-muted-foreground animate-pulse">Loading...</h2>,
		className,
	}: {
		text?: React.ReactNode;
		className?: string;
	}) => {
		let content = text;

		if (typeof text === "string") {
			content = <h2 className="text-muted-foreground">{text}</h2>;
		}

		return (
			<div
				className={cn(
					"flex h-full flex-col items-center justify-center gap-4 p-10",
					className,
				)}
			>
				<Beer className="size-10 animate-pulse" />
				{content}
			</div>
		);
	},
);
PageLoading.displayName = "PageLoading";

export const PageLoadingFull = (props: {
	text?: React.ReactNode;
	className?: string;
}) => <PageLoading className="flex-1 w-full" {...props} />;
PageLoadingFull.displayName = "PageLoadingFull";
